// @flow
import { createSelector } from 'reselect';
import Advertiser from 'common/modules/advertiser/domain/Advertiser';
import type AppState from 'advertisers/redux/types/AppState';

export const getCurrentAdvertiser = (state: AppState): Advertiser => {
  return state.advertiser.current;
};

export const getCurrentAdvertiserReference = createSelector(getCurrentAdvertiser, (advertiser) => {
  return advertiser ? advertiser.reference : '';
});



// WEBPACK FOOTER //
// ./src/advertisers/modules/advertiser/selectors/advertiserSelectors.js